import React, {useEffect} from 'react';
import {Col, Row} from 'reactstrap';
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";

// components
import { showLoader} from "../../../components/loader/loader";

// actions
import {
    setForm,
    setApp,
    ADD_STATE,
    REMOVE_STATE,
    setUdn, setMapConfig
} from "../../../redux/actions/generics/IndexedActions";
import UdnList from "./_list";



function UdnGeneral(props) {
    const path = props.path || 'core/udn';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { loading } = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    { componentState && <UdnList path={path} generalPropouse={true}/> }
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = _ => ({
});

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setUdn,
    setForm,
    setApp,
    setMapConfig,
});

export default connect(mapStateToProps, mapActionsToProps)(UdnGeneral)

